import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, of, Subscription ,from} from "rxjs";
import {MaterialInstance, MaterialService} from "../shared/classes/material.service";
 import {StreamsService}  from "../shared/services/streams.service";
import {WatchTokenService}  from "../shared/services/watch-token.service";

import {StreamProject} from "../shared/interfaces";
import { switchMap, catchError, map, delay} from 'rxjs/operators';
import { ActivatedRoute, Router} from '@angular/router';
import { watchKeyParam } from '../shared/config';
 
@Component({
  selector: 'app-watchers-embed-page',
  templateUrl: './watchers-embed-page.component.html',
  styleUrls: ['./watchers-embed-page.component.scss'],
 
})
export class WatchersEmbedPageComponent {
 
  
  constructor(
    public streamsService: StreamsService,
    public tokenService: WatchTokenService,
    public route:  ActivatedRoute,
      private router: Router
    ){
	// window.location = 'https://google.ru'
 
  } 

  stream: StreamProject = null
  streamSubscribtion: any = false
  initialLoading: boolean = true
  accessOk: boolean = null
  isEmbed: boolean = false
sessionKey;
  autoplay: boolean = true
  //stream$:Observable<StreamProject>

  watchersExceededLimit = false
  codeFromEmbed = false
  ngOnInit() { 
   

    this.streamSubscribtion = from(this.route.queryParams.pipe(
     // delay(5000),
      switchMap((params: any)=>{


		if(params['autoplay']  === 'none'){
   			this.autoplay = false
		}

		if(params[watchKeyParam]?.length){
 		   this.codeFromEmbed = params[watchKeyParam]
		}
        
          this.isEmbed = true
      

         return this.streamsService.getPubliishByPublicKey(params['v']).pipe(

	
		 catchError((error) => {
 
                    // if(error.status === 404){ this.router.navigate(['/channel']);  return of({}) }
                    if(error.status === 412){ this.watchersExceededLimit = true;  return of({}) }
			this.stream = <StreamProject>{}
			return of({})	
		} ),


          switchMap((stream: any)=>{

            if(stream.accessLevel === 0){
 
              this.tokenService.deleteToken(stream.publicIdentity)
              this.accessOk = true
              return of(stream)
            }else{

                const potentialToken = this.tokenService.getToken(stream.publicIdentity)
  
                if(!potentialToken){
                  this.accessOk = false
                  return of(stream)
                } else {
 
                  return this.streamsService.checkWatchAccessToken(stream._id,potentialToken).pipe(
                    switchMap((data: any)=>{
                    
 
                      if(data.error){
                        this.tokenService.deleteToken(stream.publicIdentity)
                        this.accessOk = false
                        return of(stream)
                      }

                      
                
                      if(data.token){
                        this.tokenService.setToken(stream.publicIdentity, data.token)
                        this.accessOk = true
                        return of(stream)
                      }  else {
                        this.accessOk = false
                        return of(stream)
                      }
                      
                    }),
                    catchError((error)=>{

                      MaterialService.toast('Сталася помилка сервера')
                    
                      console.log(error)
                        const potentialToken = this.tokenService.deleteToken(stream.publicIdentity)
                    
                      this.accessOk = false
                      return of(stream)
                    }) 
                  )
                  //.subscribe((x)=>of(x))
                }
            }
    
          })
         )       
      })

    )).subscribe((stream:any)=>{
     
      this.initialLoading = false
	 this.sessionKey = stream.session?.local_session_id
      this.stream = stream
    })/**/
   


   /* this.route.params.pipe(
      switchMap((params: Params)=>{
        return this.streamsService.getById(params['id'])
      })
    ).subscribe((stream : StreamProject)=>{
      this.stream = stream

      this.initialLoaing = false
     }) */
  }



  onAuth(data){ 
  
     if(data.success){
      this.accessOk = true
    }
  }


  closeByToken(){
     this.accessOk = false
  }
 
 
 

 
   ngOnDestroy() { 
 
      if(this.streamSubscribtion){
        // this.streamSubscribtion.unsubsceibe()
      }
    
   }


}
